import { HighlightProps } from 'react-instantsearch-core';
import { SearchObject } from './Models';
import { useTheme } from '@mui/material';
import { Fragment } from 'react/jsx-runtime';

interface IHighlightProps extends HighlightProps<SearchObject> {
  highlight: (params: {
    highlightProperty: string;
    attribute: string;
    hit: SearchObject;
  }) => Array<{ value: string; isHighlighted: boolean }>;
  attribute: string;
  hit: SearchObject;
}

const Highlight: React.FC<IHighlightProps> = (props) => {
  const theme = useTheme();
  const { highlight, attribute, hit } = props;

  const parsedHit = highlight({
    highlightProperty: '_highlightResult',
    attribute,
    hit
  });

  return (
    <Fragment>
      {parsedHit.map((part, index) =>
        part.isHighlighted ? (
          <mark key={index} style={{ backgroundColor: theme.palette.grey[100] }}>
            {part.value}
          </mark>
        ) : (
          <span key={index}>{part.value}</span>
        )
      )}
    </Fragment>
  );
};

export default Highlight;
